module.exports = __webpack_public_path__ + "img/under_review_status_icon.25232e1d.png";